import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "page-oc-submit" }

import { onMounted } from 'vue';
  import Submit from '@/components/offline-collection/submit.vue';

  
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

  onMounted(() => {});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Submit, { type: "OfflineCollection" })
  ]))
}
}

})